import { Component, Inject, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { ConfirmDailogueComponent } from 'src/app/shared/components/dailogue/confirm-dailogue.component';
import { Api } from 'src/app/shared/constants/api';
import { APP_ROUTES } from 'src/app/shared/constants/approutes';
import { Message } from 'src/app/shared/constants/message';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IPermissionWithShow } from 'src/app/shared/interface';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { SharedFormService } from 'src/app/shared/services/SharedFormService.service';
import * as _ from 'underscore';

@Component({
    selector: 'app-commodity-form',
    templateUrl: './commodity-form.component.html',
    styleUrls: ['./commodity-form.component.less'],
    standalone: false
})
export class CommodityFormComponent implements OnInit {

  commodityForm: FormGroup;
  commodityTypes:any;
  commodityGroups: any;
  editPermission:boolean=false;
  selectedSpecial: boolean = false;
  selectedHAZ: Boolean = false;
  isEditedData:boolean=false;
  yesNoList=this.utilityService.getYesNoList();
  @Output() commodityData= new EventEmitter<any>();
  commodityNameEdit:string;

  constructor(  private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dailogRef : MatDialogRef<CommodityFormComponent>,
    private service:DataService,
    private utilityService: UtilityService, private logger : NGXLogger,
    private dailog:MatDialog,
    private router:Router,
    private permissionService:PermissionService,
    private sharedFormService:SharedFormService) { this.dailogRef.disableClose=true; }

ngOnInit(): void {
  this.checkAllPermission();
  this.initializeCommodityForm();
  this.getTypes();
  this.getGroups();
  this.patchValue();
  this.setTypeValueChangeEvent();
}

private initializeCommodityForm(){
  this.commodityForm = this.formBuilder.group({
    id:[],
    name:[null,[Validators.required]],
    commodityType:[null,[Validators.required]],
    hsCode:[null,[Validators.required]],
    commodityGroup:[],
    imdgClass:[],
    imdgClassName:[],
    viewLog:[],
    parentId:[],
  });
}

private patchValue() {
  if(this.data.isCfs)
    this.logger.info('shipping bill obj ',this.data);
  else if (this.data?.id) 
    this.logger.info("Checking the Values of the DATA",this.data);
    this.commodityForm.patchValue(this.data);
} 

setTypeValueChangeEvent(){
  this.commodityType.valueChanges.subscribe((type: string) => {
      if(type=="HAZ"){
        this.imdgClass.setValidators([Validators.required]);
        this.imdgClassName.setValidators([Validators.required]);
        this.commodityForm.updateValueAndValidity();
        this.resetValidatorAndValueIfHAZSelected();
      }
      else if(type=="SPECIAL"){
        this.commodityGroup.setValidators([Validators.required]);
        this.commodityForm.updateValueAndValidity();
        this.resetValidatorAndValueIfSpecialSelected();
      } 
      else{
        this.resetValidatorAndValueIfHAZSelected();
        this.resetValidatorAndValueIfSpecialSelected();
      }
  })
}

private resetValidatorAndValueIfSpecialSelected() {
  this.imdgClass.clearValidators();
  this.imdgClassName.clearValidators();
  this.imdgClassName.reset();
  this.imdgClass.reset();
  this.imdgClass.updateValueAndValidity();
  this.imdgClassName.updateValueAndValidity();
}

private resetValidatorAndValueIfHAZSelected() {
  this.commodityGroup.clearValidators();
  this.commodityGroup.reset();
  this.commodityGroup.updateValueAndValidity();
}

save(){
  this.commodityForm.markAllAsTouched();
  if(this.commodityForm.valid)
  {
    this.isEditedData=true;
      if(this.id.value){
        this.openDailog(Message.SAVE_OPEN_DAILOG_IN_EDIT);
      }
      else {
        this.openDailog(Message.SAVE_OPEN_DAILOG);
      }  
  }
}

saveCommodityModule(){
  this.logger.info('Commodity Form Value before validation',this.commodityForm.getRawValue());
  this.commodityForm.markAllAsTouched();
  let method=(this.id.value)?'put':'post';
  let message=(this.id.value)?'updated':'saved';
  if(this.commodityForm.valid)
  {
    this.name.patchValue(this.name.value.trim().replace(/ +/g, ' '));
    this.hsCode.patchValue(this.hsCode.value.trim().replace(/ +/g, ' '));
    if(this.commodityType.value == 'HAZ'){
      this.imdgClass.patchValue(this.imdgClass.value.trim().replace(/ +/g, ' '));
      this.imdgClassName.patchValue(this.imdgClassName.value.trim().replace(/ +/g, ' '));
    }
    this.service[method](Api.COMMODITY,this.commodityForm.getRawValue()).subscribe(res => {
      if(res){
        this.logger.info('Commodity Saved Res',res);
        this.utilityService.notifier('commodity Details '+message+' successfully', 'success');
        this.data?.commodityDetails?.forEach((row,index)=> {
          if(this.data.index === index) {
            row.commodityId = res.id; row.commodityType = res.commodityType; row.imdgClass = res.imdgClass;
          }
          if (!row.commodityList.some((item) => item.id === res.id)) {
              row.commodityList.push(res);
          }
        });
        this.logger.info('data ',this.data);
        this.commodityNameEdit = this.commodityForm.value
        if (this.data?.isCfs || this.data?.isHub) {
          this.dailogRef.close(this.data);
        } else {
          this.dailogRef.close(this.commodityForm);
        }
        }
      });
    }
  }

public cancel() {
  this.logger.debug("Cancel triggered, form state:", this.data);
  if(this.commodityForm.dirty){
    this.isEditedData=false;
    this.openDailog(Message.CANCEL_OPEN_DAILOG_IN_EDIT);
  }
  else{
    this.navigateAccordingToFlag();
    this.dailogRef.close();
  }
}

private openDailog(message?: string) {
  const dialogRef = this.dailog.open(ConfirmDailogueComponent, {
    data: message,
    maxWidth: "300px",
    maxHeight: "150px"
  });

  dialogRef.afterClosed().subscribe(dailogResult => {
    if (dailogResult === false) {
      return;
    }
    if (!this.isEditedData) {
      this.navigateAccordingToFlag();
      this.dailogRef.close();
    } else {
      this.saveCommodityModule();
    }
  });
}

private navigateAccordingToFlag(): void {
  if (this.data?.isCfs) {
    this.sharedFormService.setFormState('CFS', this.data);
    this.data?.id
      ? this.router.navigate([`${APP_ROUTES.SHIPPING_BILL}/cfs/edit/`, this.data.id], { skipLocationChange: true })
      : this.router.navigate([`${APP_ROUTES.SHIPPING_BILL}/cfs/add/`], { skipLocationChange: true });

  } else if (this.data?.isHub) {
    this.sharedFormService.setFormState('HUB', this.data);
    this.data?.id
      ? this.router.navigate([`${APP_ROUTES.SHIPPING_BILL}/hub/edit/`, this.data.id], { skipLocationChange: true })
      : this.router.navigate([`${APP_ROUTES.SHIPPING_BILL}/hub/add/`], { skipLocationChange: true });

  } else {
    this.router.navigate([APP_ROUTES.COMMODITY]);
  }
}

getTypes(){
  this.service.get(Api.COMMODITY_TYPES, this.commodityForm).subscribe(res => {
      if(res){
        this.commodityTypes=res;
      }
  })
}

getGroups(){
  this.service.get(Api.COMMODITY_GROUPS, this.commodityForm).subscribe(res => {
      if(res){
        this.commodityGroups=res;
      }
  })
}

public checkAllPermission(){
  let permissionCodes=[PermissionKey.COMMODITY_MODULE_EDIT_PERMISSION];
  let permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.COMMODITY_MODULE);
  this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.COMMODITY_MODULE_EDIT_PERMISSION})?.show?true:false;
}

  get id(){return this.commodityForm.get('id')};
  get name(){return this.commodityForm.get('name')};
  get commodityType(){ return this.commodityForm.get('commodityType')};
  get hsCode(){ return this.commodityForm.get('hsCode')};
  get commodityGroup(){return this.commodityForm.get('commodityGroup')};
  get imdgClass(){ return this.commodityForm.get('imdgClass')};
  get imdgClassName(){ return this.commodityForm.get('imdgClassName')};
  get viewLog(){ return this.commodityForm.get('viewLog')};
}
